import { gql } from 'graphql-request';

export const SUBSCRIPTION_FIELDS = gql`
  fragment SubscriptionFields on SubscriptionDto {
    id
    organizationId
    status
    adminSeats
    userSeats
    adminSeatsInUse
    userSeatsInUse
  }
`;

export const SUBSCRIPTION_SESSION_FIELDS = gql`
  fragment SubscriptionSessionFields on SubscriptionSessionDto {
    subscriptionId
    stripeSubscriptionId
    stripeCustomerId
    clientSecret
    adminSeats
    userSeats
    status
  }
`;

export const getSubscriptions = gql`
  query getSubscriptions($subscriptions: GetSubscriptionsInput!) {
    getSubscriptions(subscriptions: $subscriptions) {
      subscriptions {
        ...SubscriptionFields
        cancelAtPeriodEnd
        organizationName
        createdAt
        updatedAt
      }
      count
    }
  }
  ${SUBSCRIPTION_FIELDS}
`;

export const createSubscriptionSession = gql`
  mutation createSubscriptionSession($input: CreateSubscriptionSessionInput!) {
    createSubscriptionSession(input: $input) {
      ...SubscriptionSessionFields
    }
  }
  ${SUBSCRIPTION_SESSION_FIELDS}
`;

export const updateSubscriptionSeats = gql`
  mutation updateSubscriptionSeats($input: UpdateSubscriptionSeatsInput!) {
    updateSubscriptionSeats(input: $input) {
      ...SubscriptionFields
    }
  }
  ${SUBSCRIPTION_FIELDS}
`;

export const cancelSubscription = gql`
  mutation cancelSubscription($input: CancelSubscriptionInput!) {
    cancelSubscription(input: $input) {
      ...SubscriptionFields
    }
  }
  ${SUBSCRIPTION_FIELDS}
`;

export const getStripePriceConfig = gql`
  query getStripePriceConfig {
    getStripePriceConfig {
      adminPriceId
      userPriceId
    }
  }
`;

export const getActiveSubscription = gql`
  query getActiveSubscription {
    getActiveSubscription {
      ...SubscriptionFields
      stripeSubscriptionId
      stripeCustomerId
      cancelAtPeriodEnd
      createdAt
      updatedAt
      cancelAt
      currentPeriodEnd
      currentPeriodStart

    }
  }
  ${SUBSCRIPTION_FIELDS}
`;

export const getInvoicesByOrganization = gql`
  query getInvoicesByOrganization {
    getInvoicesByOrganization {
      id
      organizationId
      subscriptionId
      stripeId
      stripeSubscriptionId
      amount
      currency
      status
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const validateCoupon = gql`
  query validateCoupon($input: ValidateCouponInput!) {
    validateCoupon(input: $input) {
      valid
      couponId
      percentOff
      amountOff
      currency
      duration
      durationInMonths
      originalAmount
      discountAmount
      finalAmount
      errorMessage
    }
  }
`;

export const createBillingPortalSession = gql`
  mutation createBillingPortalSession {
    createBillingPortalSession {
      url
    }
  }
`;

const SubscriptionGraphQL = {
  queries: {
    getSubscriptions,
    getStripePriceConfig,
    getActiveSubscription,
    getInvoicesByOrganization,
    validateCoupon,
  },
  mutations: {
    createSubscriptionSession,
    updateSubscriptionSeats,
    cancelSubscription,
    createBillingPortalSession,
  },
};

export default SubscriptionGraphQL;
